module.exports = __webpack_public_path__ + "assets/df1d1c78b0a947affa4c841e8e9110fc.mp3";